import { SortOrder } from '../enums';
import { PaginationInformation } from './pagination-information';

export class SearchInput<T>{
    public isDeleted?: boolean | null;
    public searchText: string;
    public sortType: T;
    public sortOrder: SortOrder;

    public paginationInformation: PaginationInformation;

    constructor(sortType: T) {
        this.isDeleted = false;
        this.searchText = '';
        this.sortType = sortType;
        this.sortOrder = SortOrder.Descending;
        this.paginationInformation = new PaginationInformation();
    }
}